const Utils = {
  fileDownload(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
  },

  pad(target, size, leading = '0') {
    let string = String(target)

    while (string.length < (size || 2)) {
      string = leading + string
    }

    return string
  },

  // Calculate the bounds of rectangle
  rectangleBounds(vertexes) {
    if (vertexes.length >= 2) {
      const northEast = [0, 0];
      const southWest = [0, 0];

      // get them minimum and maximum values of longitude
      const lngs = [];
      vertexes.forEach((element) => {
        lngs.push(element.lng);
      });
      northEast[1] = Math.max(...lngs);
      southWest[1] = Math.min(...lngs);

      // get them minimum and maximum values of latitude
      const lats = [];
      vertexes.forEach((element) => {
        lats.push(element.lat);
      });
      northEast[0] = Math.max(...lats);
      southWest[0] = Math.min(...lats);

      return [northEast, southWest];
    } else {
      return null;
    }
  },

  // Calculate the map bounds
  mapBounds(coordinates, isForMarker = false) {
    if (coordinates.length >= 2) {
      // get them minimum and maximum values of longitude
      const lngs = [];
      coordinates.forEach((element) => {
        if (isForMarker) {
          lngs.push(element.latlng[1]);
        } else {
          lngs.push(element.lng);
        }
      });
      const east = Math.max(...lngs);
      const west = Math.min(...lngs);

      // get them minimum and maximum values of latitude
      const lats = [];
      coordinates.forEach((element) => {
        if (isForMarker) {
          lats.push(element.latlng[0]);
        } else {
          lats.push(element.lat);
        }
      });
      const north = Math.max(...lats);
      const south = Math.min(...lats);

      if (east === west || north === south) {
        return [[north + 10, east + 10], [south - 10, west - 10]];
      } else {
        return [[north + 1, east + 1], [south - 1, west - 1]];
      }
    } else {
      return null;
    }
  },

  countries() {
    return [
      { key: 'WORLD', value: '全部國家' },
      { key: 'AF', value: 'Afghanistan (阿富汗)' },
      { key: 'AX', value: 'Åland Islands (奧蘭)' },
      { key: 'AL', value: 'Albania (阿爾巴尼亞)' },
      { key: 'DZ', value: 'Algeria (阿爾及利亞)' },
      { key: 'AS', value: 'American Samoa (美屬薩摩亞)' },
      { key: 'AD', value: 'Andorra (安道爾)' },
      { key: 'AO', value: 'Angola (安哥拉)' },
      { key: 'AI', value: 'Anguilla (安圭拉)' },
      { key: 'AQ', value: 'Antarctica (南極洲)' },
      { key: 'AG', value: 'Antigua and Barbuda (安地卡及巴布達)' },
      { key: 'AR', value: 'Argentina (阿根廷)' },
      { key: 'AM', value: 'Armenia (亞美尼亞)' },
      { key: 'AW', value: 'Aruba (阿魯巴)' },
      { key: 'AU', value: 'Australia (澳大利亞)' },
      { key: 'AT', value: 'Austria (奧地利)' },
      { key: 'AZ', value: 'Azerbaijan (亞塞拜然)' },
      { key: 'BS', value: 'Bahamas (巴哈馬)' },
      { key: 'BH', value: 'Bahrain (巴林)' },
      { key: 'BD', value: 'Bangladesh (孟加拉國)' },
      { key: 'BB', value: 'Barbados (巴貝多)' },
      { key: 'BY', value: 'Belarus (白俄羅斯)' },
      { key: 'BE', value: 'Belgium (比利時)' },
      { key: 'BZ', value: 'Belize (貝里斯)' },
      { key: 'BJ', value: 'Benin (貝南)' },
      { key: 'BM', value: 'Bermuda (百慕達)' },
      { key: 'BT', value: 'Bhutan (不丹)' },
      { key: 'BO', value: 'Bolivia (Plurinational State of) (玻利維亞)' },
      { key: 'BQ', value: 'Bonaire, Sint Eustatius and Saba (加勒比荷蘭)' },
      { key: 'BA', value: 'Bosnia and Herzegovina (波士尼亞與赫塞哥維納)' },
      { key: 'BW', value: 'Botswana (波札那)' },
      { key: 'BV', value: 'Bouvet Island (布韋島)' },
      { key: 'BR', value: 'Brazil (巴西)' },
      { key: 'IO', value: 'British Indian Ocean Territory (英屬印度洋領地)' },
      { key: 'BN', value: 'Brunei Darussalam (汶萊)' },
      { key: 'BG', value: 'Bulgaria (保加利亞)' },
      { key: 'BF', value: 'Burkina Faso (布吉納法索)' },
      { key: 'BI', value: 'Burundi (蒲隆地)' },
      { key: 'CV', value: 'Cabo Verde (維德角)' },
      { key: 'KH', value: 'Cambodia (柬埔寨)' },
      { key: 'CM', value: 'Cameroon (喀麥隆)' },
      { key: 'CA', value: 'Canada (加拿大)' },
      { key: 'KY', value: 'Cayman Islands (開曼群島)' },
      { key: 'CF', value: 'Central African Republic (中非)' },
      { key: 'TD', value: 'Chad (查德)' },
      { key: 'CL', value: 'Chile (智利)' },
      { key: 'CN', value: 'China (中國)' },
      { key: 'CX', value: 'Christmas Island (聖誕島)' },
      { key: 'CC', value: 'Cocos (Keeling) Islands (科科斯（基林）群島)' },
      { key: 'CO', value: 'Colombia (哥倫比亞)' },
      { key: 'KM', value: 'Comoros (葛摩)' },
      { key: 'CD', value: 'Congo (Democratic Republic of the) (剛果民主共和國)' },
      { key: 'CG', value: 'Congo (剛果共和國)' },
      { key: 'CK', value: 'Cook Islands (庫克群島)' },
      { key: 'CR', value: 'Costa Rica (哥斯大黎加)' },
      { key: 'CI', value: 'Côte d\'Ivoire (象牙海岸)' },
      { key: 'HR', value: 'Croatia (克羅埃西亞)' },
      { key: 'CU', value: 'Cuba (古巴)' },
      { key: 'CW', value: 'Curaçao (庫拉索)' },
      { key: 'CY', value: 'Cyprus (賽普勒斯)' },
      { key: 'CZ', value: 'Czechia (捷克)' },
      { key: 'DK', value: 'Denmark (丹麥)' },
      { key: 'DJ', value: 'Djibouti (吉布地)' },
      { key: 'DM', value: 'Dominica (多米尼克)' },
      { key: 'DO', value: 'Dominican Republic (多明尼加)' },
      { key: 'EC', value: 'Ecuador (厄瓜多)' },
      { key: 'EG', value: 'Egypt (埃及)' },
      { key: 'SV', value: 'El Salvador (薩爾瓦多)' },
      { key: 'GQ', value: 'Equatorial Guinea (赤道幾內亞)' },
      { key: 'ER', value: 'Eritrea (厄利垂亞)' },
      { key: 'EE', value: 'Estonia (愛沙尼亞)' },
      { key: 'ET', value: 'Ethiopia (衣索比亞)' },
      { key: 'FK', value: 'Falkland Islands (Malvinas) (福克蘭群島)' },
      { key: 'FO', value: 'Faroe Islands (法羅群島)' },
      { key: 'FJ', value: 'Fiji (斐濟)' },
      { key: 'FI', value: 'Finland (芬蘭)' },
      { key: 'FR', value: 'France (法國)' },
      { key: 'GF', value: 'French Guiana (法屬圭亞那)' },
      { key: 'PF', value: 'French Polynesia (法屬玻里尼西亞)' },
      { key: 'TF', value: 'French Southern Territories (法屬南部領地)' },
      { key: 'GA', value: 'Gabon (加彭)' },
      { key: 'GM', value: 'Gambia (甘比亞)' },
      { key: 'GE', value: 'Georgia (喬治亞)' },
      { key: 'DE', value: 'Germany (德國)' },
      { key: 'GH', value: 'Ghana (加納)' },
      { key: 'GI', value: 'Gibraltar (直布羅陀)' },
      { key: 'GR', value: 'Greece (希臘)' },
      { key: 'GL', value: 'Greenland (格陵蘭)' },
      { key: 'GD', value: 'Grenada (格瑞那達)' },
      { key: 'GP', value: 'Guadeloupe (瓜德羅普)' },
      { key: 'GU', value: 'Guam (關島)' },
      { key: 'GT', value: 'Guatemala (瓜地馬拉)' },
      { key: 'GG', value: 'Guernsey (根西)' },
      { key: 'GN', value: 'Guinea (幾內亞)' },
      { key: 'GW', value: 'Guinea-Bissau (幾內亞比索)' },
      { key: 'GY', value: 'Guyana (蓋亞那)' },
      { key: 'HT', value: 'Haiti (海地)' },
      { key: 'HM', value: 'Heard Island and McDonald Islands (赫德島和麥克唐納群島)' },
      { key: 'VA', value: 'Holy See (梵蒂岡)' },
      { key: 'HN', value: 'Honduras (宏都拉斯)' },
      { key: 'HK', value: 'Hong Kong (香港)' },
      { key: 'HU', value: 'Hungary (匈牙利)' },
      { key: 'IS', value: 'Iceland (冰島)' },
      { key: 'IN', value: 'India (印度)' },
      { key: 'ID', value: 'Indonesia (印尼)' },
      { key: 'IR', value: 'Iran (Islamic Republic of) (伊朗)' },
      { key: 'IQ', value: 'Iraq (伊拉克)' },
      { key: 'IE', value: 'Ireland (愛爾蘭)' },
      { key: 'IM', value: 'Isle of Man (曼島)' },
      { key: 'IL', value: 'Israel (以色列)' },
      { key: 'IT', value: 'Italy (義大利)' },
      { key: 'JM', value: 'Jamaica (牙買加)' },
      { key: 'JP', value: 'Japan (日本)' },
      { key: 'JE', value: 'Jersey (澤西)' },
      { key: 'JO', value: 'Jordan (約旦)' },
      { key: 'KZ', value: 'Kazakhstan (哈薩克)' },
      { key: 'KE', value: 'Kenya (肯亞)' },
      { key: 'KI', value: 'Kiribati (吉里巴斯)' },
      { key: 'KP', value: 'Korea (Democratic People\'s Republic of) (北韓)' },
      { key: 'KR', value: 'Korea (Republic of) (韓國)' },
      { key: 'KW', value: 'Kuwait (科威特)' },
      { key: 'KG', value: 'Kyrgyzstan (吉爾吉斯)' },
      { key: 'LA', value: 'Lao People\'s Democratic Republic (寮國)' },
      { key: 'LV', value: 'Latvia (拉脫維亞)' },
      { key: 'LB', value: 'Lebanon (黎巴嫩)' },
      { key: 'LS', value: 'Lesotho (賴索托)' },
      { key: 'LR', value: 'Liberia (賴比瑞亞)' },
      { key: 'LY', value: 'Libya (利比亞)' },
      { key: 'LI', value: 'Liechtenstein (列支敦斯登)' },
      { key: 'LT', value: 'Lithuania (立陶宛)' },
      { key: 'LU', value: 'Luxembourg (盧森堡)' },
      { key: 'MO', value: 'Macao (澳門)' },
      { key: 'MK', value: 'Macedonia (the former Yugoslav Republic of) (馬其頓)' },
      { key: 'MG', value: 'Madagascar (馬達加斯加)' },
      { key: 'MW', value: 'Malawi (馬拉威)' },
      { key: 'MY', value: 'Malaysia (馬來西亞)' },
      { key: 'MV', value: 'Maldives (馬爾地夫)' },
      { key: 'ML', value: 'Mali (馬利)' },
      { key: 'MT', value: 'Malta (馬爾他)' },
      { key: 'MH', value: 'Marshall Islands (馬紹爾群島)' },
      { key: 'MQ', value: 'Martinique (馬提尼克)' },
      { key: 'MR', value: 'Mauritania (茅利塔尼亞)' },
      { key: 'MU', value: 'Mauritius (模里西斯)' },
      { key: 'YT', value: 'Mayotte (馬約特)' },
      { key: 'MX', value: 'Mexico (墨西哥)' },
      { key: 'FM', value: 'Micronesia (Federated States of) (密克羅尼西亞聯邦)' },
      { key: 'MD', value: 'Moldova (Republic of) (摩爾多瓦)' },
      { key: 'MC', value: 'Monaco (摩納哥)' },
      { key: 'MN', value: 'Mongolia (蒙古)' },
      { key: 'ME', value: 'Montenegro (蒙特內哥羅)' },
      { key: 'MS', value: 'Montserrat (蒙特塞拉特)' },
      { key: 'MA', value: 'Morocco (摩洛哥)' },
      { key: 'MZ', value: 'Mozambique (莫三比克)' },
      { key: 'MM', value: 'Myanmar (緬甸)' },
      { key: 'NA', value: 'Namibia (納米比亞)' },
      { key: 'NR', value: 'Nauru (諾魯)' },
      { key: 'NP', value: 'Nepal (尼泊爾)' },
      { key: 'NL', value: 'Netherlands (荷蘭)' },
      { key: 'NC', value: 'New Caledonia (新喀里多尼亞)' },
      { key: 'NZ', value: 'New Zealand (紐西蘭)' },
      { key: 'NI', value: 'Nicaragua (尼加拉瓜)' },
      { key: 'NE', value: 'Niger (尼日)' },
      { key: 'NG', value: 'Nigeria (奈及利亞)' },
      { key: 'NU', value: 'Niue (紐埃)' },
      { key: 'NF', value: 'Norfolk Island (諾福克島)' },
      { key: 'MP', value: 'Northern Mariana Islands (北馬里亞納群島)' },
      { key: 'NO', value: 'Norway (挪威)' },
      { key: 'OM', value: 'Oman (阿曼)' },
      { key: 'PK', value: 'Pakistan (巴基斯坦)' },
      { key: 'PW', value: 'Palau (帛琉)' },
      { key: 'PS', value: 'Palestine, State of (巴勒斯坦)' },
      { key: 'PA', value: 'Panama (巴拿馬)' },
      { key: 'PG', value: 'Papua New Guinea (巴布亞紐幾內亞)' },
      { key: 'PY', value: 'Paraguay (巴拉圭)' },
      { key: 'PE', value: 'Peru (秘魯)' },
      { key: 'PH', value: 'Philippines (菲律賓)' },
      { key: 'PN', value: 'Pitcairn (皮特凱恩群島)' },
      { key: 'PL', value: 'Poland (波蘭)' },
      { key: 'PT', value: 'Portugal (葡萄牙)' },
      { key: 'PR', value: 'Puerto Rico (波多黎各)' },
      { key: 'QA', value: 'Qatar (卡達)' },
      { key: 'RE', value: 'Réunion (留尼旺)' },
      { key: 'RO', value: 'Romania (羅馬尼亞)' },
      { key: 'RU', value: 'Russian Federation (俄羅斯)' },
      { key: 'RW', value: 'Rwanda (盧安達)' },
      { key: 'BL', value: 'Saint Barthélemy (聖巴泰勒米)' },
      { key: 'SH', value: 'Saint Helena, Ascension and Tristan da Cunha (聖赫勒拿)' },
      { key: 'KN', value: 'Saint Kitts and Nevis (聖克里斯多福及尼維斯)' },
      { key: 'LC', value: 'Saint Lucia (聖露西亞)' },
      { key: 'MF', value: 'Saint Martin (French part) (法屬聖馬丁)' },
      { key: 'PM', value: 'Saint Pierre and Miquelon (聖皮埃爾和密克隆)' },
      { key: 'VC', value: 'Saint Vincent and the Grenadines (聖文森及格瑞那丁)' },
      { key: 'WS', value: 'Samoa (薩摩亞)' },
      { key: 'SM', value: 'San Marino (聖馬利諾)' },
      { key: 'ST', value: 'Sao Tome and Principe (聖多美和普林西比)' },
      { key: 'SA', value: 'Saudi Arabia (沙烏地阿拉伯)' },
      { key: 'SN', value: 'Senegal (塞內加爾)' },
      { key: 'RS', value: 'Serbia (塞爾維亞)' },
      { key: 'SC', value: 'Seychelles (塞席爾)' },
      { key: 'SL', value: 'Sierra Leone (獅子山)' },
      { key: 'SG', value: 'Singapore (新加坡)' },
      { key: 'SX', value: 'Sint Maarten (Dutch part) (荷屬聖馬丁)' },
      { key: 'SK', value: 'Slovakia (斯洛伐克)' },
      { key: 'SI', value: 'Slovenia (斯洛維尼亞)' },
      { key: 'SB', value: 'Solomon Islands (索羅門群島)' },
      { key: 'SO', value: 'Somalia (索馬利亞)' },
      { key: 'ZA', value: 'South Africa (南非)' },
      { key: 'GS', value: 'South Georgia and the South Sandwich Islands (南喬治亞和南桑威奇群島)' },
      { key: 'SS', value: 'South Sudan (南蘇丹)' },
      { key: 'ES', value: 'Spain (西班牙)' },
      { key: 'LK', value: 'Sri Lanka (斯里蘭卡)' },
      { key: 'SD', value: 'Sudan (蘇丹)' },
      { key: 'SR', value: 'Suriname (蘇利南)' },
      { key: 'SJ', value: 'Svalbard and Jan Mayen (斯瓦爾巴群島和揚馬延島)' },
      { key: 'SZ', value: 'Swaziland (史瓦濟蘭)' },
      { key: 'SE', value: 'Sweden (瑞典)' },
      { key: 'CH', value: 'Switzerland (瑞士)' },
      { key: 'SY', value: 'Syrian Arab Republic (敘利亞)' },
      { key: 'TW', value: 'Taiwan (臺灣)' },
      { key: 'TJ', value: 'Tajikistan (塔吉克)' },
      { key: 'TZ', value: 'Tanzania, United Republic of (坦尚尼亞)' },
      { key: 'TH', value: 'Thailand (泰國)' },
      { key: 'TL', value: 'Timor-Leste (東帝汶)' },
      { key: 'TG', value: 'Togo (多哥)' },
      { key: 'TK', value: 'Tokelau (托克勞)' },
      { key: 'TO', value: 'Tonga (東加)' },
      { key: 'TT', value: 'Trinidad and Tobago (千里達及托巴哥)' },
      { key: 'TN', value: 'Tunisia (突尼西亞)' },
      { key: 'TR', value: 'Turkey (土耳其)' },
      { key: 'TM', value: 'Turkmenistan (土庫曼)' },
      { key: 'TC', value: 'Turks and Caicos Islands (特克斯與凱科斯群島)' },
      { key: 'TV', value: 'Tuvalu (吐瓦魯)' },
      { key: 'UG', value: 'Uganda (烏干達)' },
      { key: 'UA', value: 'Ukraine (烏克蘭)' },
      { key: 'AE', value: 'United Arab Emirates (阿聯)' },
      { key: 'GB', value: 'United Kingdom of Great Britain and Northern Ireland (英國)' },
      { key: 'UM', value: 'United States Minor Outlying Islands (美國本土外小島嶼)' },
      { key: 'US', value: 'United States of America (美國)' },
      { key: 'UY', value: 'Uruguay (烏拉圭)' },
      { key: 'UZ', value: 'Uzbekistan (烏茲別克)' },
      { key: 'VU', value: 'Vanuatu (萬那杜)' },
      { key: 'VE', value: 'Venezuela (Bolivarian Republic of) (委內瑞拉)' },
      { key: 'VN', value: 'Viet Nam (越南)' },
      { key: 'VG', value: 'Virgin Islands (British) (英屬維京群島)' },
      { key: 'VI', value: 'Virgin Islands (U.S.) (美屬維京群島)' },
      { key: 'WF', value: 'Wallis and Futuna (瓦利斯和富圖納)' },
      { key: 'EH', value: 'Western Sahara (撒拉威阿拉伯民主共和國)' },
      { key: 'YE', value: 'Yemen (葉門)' },
      { key: 'ZM', value: 'Zambia (尚比亞)' },
      { key: 'ZW', value: 'Zimbabwe (辛巴威)' }
    ]
  }
}

export default Utils
